module.exports = __webpack_public_path__ + "static/media/qrCode.83e70abd.svg";